import Vue from 'vue'
//import App from "./App.vue"
//import App from "./App_Mobile.vue"
import App from "./App_K1.vue"

Vue.config.productionTip = false

webConfig.vm = new Vue({// eslint-disable-line no-undef
  render: h => h(App)
}).$mount('#app')

